import axios from "axios"
// import { cacheAdapterEnhancer } from 'axios-extensions'

// Create Axios Instance
const instance = axios.create({
        baseURL: "/api",
        withCredentials: true,
        headers: { "Cache-Control": "no-cache" }
        // cache will be enabled by default
        // adapter: cacheAdapterEnhancer(axios.defaults.adapter)
})

export default instance

